module.exports = __webpack_public_path__ + "img/1541400889.933fb746.jpg";